window.field_data = {
    "data": [
        {
            "fieldname": "Photo Magnets 6 7 x 7 cm",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please upload your photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Photo magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058936463683"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Size://?//7 x 7 cm",
                "Equals//?//Select Quantity://?//6"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058936463683",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Custom_Photo_1.jpg?v=1757108771",
                    "title": "Photo magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53645189775683",
                            "title": "7 x 7 cm / 6",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_192234.jpg?v=1757108912"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Photo Magnets 6 7 x 9 cm",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "f you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please upload your photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "3:4, 4:3",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Photo magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058936463683"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Size://?//7 x 9 cm",
                "Equals//?//Select Quantity://?//6"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058936463683",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Custom_Photo_1.jpg?v=1757108771",
                    "title": "Photo magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53645189808451",
                            "title": "7 x 9 cm / 6",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_193528.jpg?v=1757108868"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Photo Magnets 6 8 x 10 cm",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "f you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please upload your photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "3:4, 4:3",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Photo magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058936463683"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Size://?//8 x 10 cm",
                "Equals//?//Select Quantity://?//6"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058936463683",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Custom_Photo_1.jpg?v=1757108771",
                    "title": "Photo magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53645213663555",
                            "title": "8 x 10 cm / 6",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_194636.jpg?v=1757108848"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Photo Magnets 12 7 x 7 cm",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "f you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 12,
            "minimumfiles": 12,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please upload your photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Photo magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058936463683"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Size://?//7 x 7 cm",
                "Equals//?//Select Quantity://?//12"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058936463683",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Custom_Photo_1.jpg?v=1757108771",
                    "title": "Photo magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53645237256515",
                            "title": "7 x 7 cm / 12",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_192603.jpg?v=1757108931"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Photo Magnets 12 7 x 9 cm",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "f you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 12,
            "minimumfiles": 12,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please upload your photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "3:4, 4:3",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Photo magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058936463683"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Size://?//7 x 9 cm",
                "Equals//?//Select Quantity://?//12"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058936463683",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Custom_Photo_1.jpg?v=1757108771",
                    "title": "Photo magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53645237289283",
                            "title": "7 x 9 cm / 12",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_193837.jpg?v=1757108887"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Photo Magnets 12 8 x 10 cm",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "f you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 12,
            "minimumfiles": 12,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please upload your photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "3:4, 4:3",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Photo magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058936463683"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Size://?//8 x 10 cm",
                "Equals//?//Select Quantity://?//12"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058936463683",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Custom_Photo_1.jpg?v=1757108771",
                    "title": "Photo magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53645237322051",
                            "title": "8 x 10 cm / 12",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_194847.jpg?v=1757108827"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Photo Magnet Calendar",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 12,
            "minimumfiles": 12,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Enable",
            "textFieldName": "Month:",
            "fieldHelpText": "",
            "textFieldMaxLength": "Yes",
            "textFieldMaxChars": "15",
            "textFieldRequired": "Yes",
            "textFieldRequiredMessage": "Type different month in every field!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please select photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Photo Magnet Calendar"
                ],
                "productIds": [
                    "gid://shopify/Product/15058939085123"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": true,
            "anyConditionVariant": false,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": true,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": false,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058939085123",
                    "title": "Photo Magnet Calendar"
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek",
                        "textFieldHeading": "Μήνας:",
                        "textFieldHelpText": "Επιλέξτε διαφορετικό μήνα σε κάθε πεδίο!"
                    }
                }
            ]
        },
        {
            "fieldname": "Magnet Pack Square",
            "directUpload": false,
            "atcTitle": "Upload your photo:",
            "uploadButtonText": "Choose file",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": true,
            "op2": false,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please upload your photo!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Magnet Pack"
                ],
                "productIds": [
                    "gid://shopify/Product/15058844483907"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Shape://?//Square",
                "Equals//?//Select Quantity://?//10",
                "Equals//?//Select Shape://?//Square",
                "Equals//?//Select Quantity://?//20",
                "Equals//?//Select Shape://?//Square",
                "Equals//?//Select Quantity://?//30",
                "Equals//?//Select Shape://?//Square",
                "Equals//?//Select Quantity://?//50",
                "Equals//?//Select Shape://?//Square",
                "Equals//?//Select Quantity://?//100"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058844483907",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_183550.jpg?v=1757109314",
                    "title": "Magnet Pack",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53645987086659",
                            "title": "Square / 10",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_183550.jpg?v=1757109314"
                        },
                        {
                            "id": "gid://shopify/ProductVariant/53645987119427",
                            "title": "Square / 20",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_183550.jpg?v=1757109314"
                        },
                        {
                            "id": "gid://shopify/ProductVariant/53645987152195",
                            "title": "Square / 30",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_183550.jpg?v=1757109314"
                        },
                        {
                            "id": "gid://shopify/ProductVariant/53645987184963",
                            "title": "Square / 50",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_183550.jpg?v=1757109314"
                        },
                        {
                            "id": "gid://shopify/ProductVariant/53645987217731",
                            "title": "Square / 100",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_183550.jpg?v=1757109314"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τη φωτογραφία σας:",
                        "buttonText": "Επιλογή φωτογραφίας",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Magnet Pack Rectangle",
            "directUpload": false,
            "atcTitle": "Upload your photo:",
            "uploadButtonText": "Choose file",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": true,
            "op2": false,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please upload your photo!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "3:4, 4:3",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Magnet Pack"
                ],
                "productIds": [
                    "gid://shopify/Product/15058844483907"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Shape://?//Rectangle",
                "Equals//?//Select Quantity://?//10",
                "Equals//?//Select Shape://?//Rectangle",
                "Equals//?//Select Quantity://?//20",
                "Equals//?//Select Shape://?//Rectangle",
                "Equals//?//Select Quantity://?//30",
                "Equals//?//Select Shape://?//Rectangle",
                "Equals//?//Select Quantity://?//50",
                "Equals//?//Select Shape://?//Rectangle",
                "Equals//?//Select Quantity://?//100"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058844483907",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_183550.jpg?v=1757109314",
                    "title": "Magnet Pack",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53646423556419",
                            "title": "Rectangle / 10",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250422_235554.jpg?v=1757109337"
                        },
                        {
                            "id": "gid://shopify/ProductVariant/53646423589187",
                            "title": "Rectangle / 20",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250422_235554.jpg?v=1757109337"
                        },
                        {
                            "id": "gid://shopify/ProductVariant/53646423621955",
                            "title": "Rectangle / 30",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250422_235554.jpg?v=1757109337"
                        },
                        {
                            "id": "gid://shopify/ProductVariant/53646423654723",
                            "title": "Rectangle / 50",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250422_235554.jpg?v=1757109337"
                        },
                        {
                            "id": "gid://shopify/ProductVariant/53646423687491",
                            "title": "Rectangle / 100",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250422_235554.jpg?v=1757109337"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τη φωτογραφία σας:",
                        "buttonText": "Επιλογή φωτογραφίας",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Puzzle Set",
            "directUpload": false,
            "atcTitle": "Upload your photo:",
            "uploadButtonText": "Choose file",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": true,
            "op2": false,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please Select Photo!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Puzzle Magnet Set"
                ],
                "productIds": [
                    "gid://shopify/Product/15064701141315"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": true,
            "anyConditionVariant": false,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": true,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": false,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15064701141315",
                    "title": "Puzzle Magnet Set",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250707_225952.jpg?v=1757107870"
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τη φωτογραφία σας:",
                        "buttonText": "Επιλογή φωτογραφίας",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Retro Photo Magnets 6 7 x 9 cm",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please select photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Retro Photo Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058937151811"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Size://?//7 x 9 cm",
                "Equals//?//Select Quantity://?//6"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058937151811",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Retro_2.jpg?v=1757108692",
                    "title": "Retro Photo Magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647396438339",
                            "title": "7 x 9 cm / 6",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_191747.jpg?v=1757108716"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Retro Photo Magnets 12 7 x 9 cm",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 12,
            "minimumfiles": 12,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please select photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Retro Photo Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058937151811"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Size://?//7 x 9 cm",
                "Equals//?//Select Quantity://?//12"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058937151811",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Retro_2.jpg?v=1757108692",
                    "title": "Retro Photo Magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647396471107",
                            "title": "7 x 9 cm / 12",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Retro_2.jpg?v=1757108692"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Save The Date Magnets",
            "directUpload": false,
            "atcTitle": "Select size and quantity first and then upload your photo:",
            "uploadButtonText": "Choose file",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": true,
            "op2": false,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Πληροφορίες:",
            "fieldHelpText": "Ονόματα, Ημερομηνία, Τοποθεσία, Νούμερο επιλεγμένης Γραμματοσειράς",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "Yes",
            "textFieldRequiredMessage": "Συμπληρώστε τις απαιτούμενες πληροφορίες!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please select photo!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Save The Date Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058935447875"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": true,
            "anyConditionVariant": false,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": true,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": false,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058935447875",
                    "title": "Save The Date Magnets",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_204942.jpg?v=1757109056"
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τη φωτογραφία σας:",
                        "buttonText": "Επιλογή φωτογραφίας",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Mini Mixed Set Button Magnet Square",
            "directUpload": false,
            "atcTitle": "Upload your photo:",
            "uploadButtonText": "Square",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "Greek",
            "dialogLanguage": "el",
            "opt1": true,
            "op2": false,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Enable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please select photo for the square magnet!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Mini Mixed Set Button Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058843828547"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": true,
            "anyConditionVariant": false,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": true,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": false,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058843828547",
                    "title": "Mini Mixed Set Button Magnets"
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τη φωτογραφία σας:",
                        "buttonText": "Τετράγωνο",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek",
                        "textFieldHeading": "Οδηγίες",
                        "textFieldHelpText": "Βοήθεια"
                    }
                }
            ]
        },
        {
            "fieldname": "Mini Mixed Set Button Magnet Rectangle",
            "directUpload": false,
            "atcTitle": "Upload your photo:",
            "uploadButtonText": "Rectangle",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": true,
            "op2": false,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please select photo for your rectangle magnet!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "3:4, 4:3",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Mini Mixed Set Button Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058843828547"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": true,
            "anyConditionVariant": false,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": true,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "expert",
            "thisProductVariants": false,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058843828547",
                    "title": "Mini Mixed Set Button Magnets"
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τη φωτογραφία σας:",
                        "buttonText": "Ορθογώνιο",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Mixed Set Button Magnets 10 Square",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Square",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please select photos for your square magnets!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Mixed set Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058833834307"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Quantity://?//10"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058833834307",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Button_Magnets_Mix.jpg?v=1757109502",
                    "title": "Mixed set Magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647624143171",
                            "title": "10",
                            "imageSrc": ""
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Τετράγωνα",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Mixed Set Button Magnets 10 Rectangular",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Rectangle",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 4,
            "minimumfiles": 4,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please select photos for your rectangular magnets!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "3:4, 4:3",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Mixed set Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058833834307"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Quantity://?//10"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058833834307",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Button_Magnets_Mix.jpg?v=1757109502",
                    "title": "Mixed set Magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647624143171",
                            "title": "10",
                            "imageSrc": ""
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Ορθογώνια",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Mixed Set Button Magnets 20 Rectangular",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Rectangle",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 8,
            "minimumfiles": 8,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please select photos for your rectangular magnets!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "3:4, 4:3",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Mixed set Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058833834307"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Quantity://?//20"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058833834307",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Button_Magnets_Mix.jpg?v=1757109502",
                    "title": "Mixed set Magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647624175939",
                            "title": "20",
                            "imageSrc": ""
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Ορθογώνια",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Set 4 Rectangular Button Magnets",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 4,
            "minimumfiles": 4,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please choose your photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "3:4, 4:3",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Rectangular Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058829312323"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Quantity://?//4"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058829312323",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Button_magnets_Rectangular.jpg?v=1757109559",
                    "title": "Rectangular Magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647630926147",
                            "title": "4",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250413_215441.jpg?v=1757109581"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Mixed Set Button Magnets 20 Square",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Square",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 12,
            "minimumfiles": 12,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please select photos for your square magnets!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Mixed set Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058833834307"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Quantity://?//20"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058833834307",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Button_Magnets_Mix.jpg?v=1757109502",
                    "title": "Mixed set Magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647624175939",
                            "title": "20",
                            "imageSrc": ""
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Τετράγωνα",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Set 8 Rectangular Button Magnets",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 8,
            "minimumfiles": 8,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please choose your photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "3:4, 4:3",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Rectangular Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058829312323"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Quantity://?//8"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058829312323",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Button_magnets_Rectangular.jpg?v=1757109559",
                    "title": "Rectangular Magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647630958915",
                            "title": "8",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_140057.jpg?v=1757109602"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Set 16 Rectangular Button Magnets",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 16,
            "minimumfiles": 16,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please choose your photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "3:4, 4:3",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Rectangular Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15058829312323"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Quantity://?//16"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058829312323",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Button_magnets_Rectangular.jpg?v=1757109559",
                    "title": "Rectangular Magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647630991683",
                            "title": "16",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Button_magnets_Rectangular.jpg?v=1757109559"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Set 9 Square Button Magnets",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 9,
            "minimumfiles": 9,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please choose your photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Square Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15006120083779"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Quantity://?//9"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15006120083779",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Button_Magnet_Square_1.jpg?v=1757109723",
                    "title": "Square Magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647638135107",
                            "title": "9",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Button_Magnet_Square_1.jpg?v=1757109723"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "Set 18 Square Button Magnets",
            "directUpload": false,
            "atcTitle": "Upload your photos:",
            "uploadButtonText": "Choose files",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": false,
            "op2": true,
            "maximumFiles": 18,
            "minimumfiles": 18,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please choose your photos!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "Square Magnets"
                ],
                "productIds": [
                    "gid://shopify/Product/15006120083779"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Quantity://?//18"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15006120083779",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Button_Magnet_Square_1.jpg?v=1757109723",
                    "title": "Square Magnets",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647638167875",
                            "title": "18",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/20250421_211003.jpg?v=1757109745"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τις φωτογραφίες σας:",
                        "buttonText": "Επιλογή φωτογραφιών",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "NFC Magnet Square",
            "directUpload": false,
            "atcTitle": "Upload your photo:",
            "uploadButtonText": "Choose file",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": true,
            "op2": false,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please choose photo for your square magnet!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "1:1",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "NFC Magnet"
                ],
                "productIds": [
                    "gid://shopify/Product/15058853069123"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Shape://?//Square"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058853069123",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Website_2__20250707_231539_0002.png?v=1754309003",
                    "title": "NFC Magnet",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647640166723",
                            "title": "Square",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Website_2__20250707_231539_0002.png?v=1754309003"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τη φωτογραφία σας:",
                        "buttonText": "Επιλογή φωτογραφίας",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        },
        {
            "fieldname": "NFC Magnet Rectangular",
            "directUpload": false,
            "atcTitle": "Upload your photo:",
            "uploadButtonText": "Choose file",
            "uploadButtonText2": "Change File",
            "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
            "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
            "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then ‘Open in Chrome’",
            "buttonTextSize": 14,
            "buttonFontSize": 14,
            "fontStyle": "Theme Font",
            "introTitleColor": "#000",
            "buttonCol": "#0b0202",
            "buttonBg": "#ADC4C2",
            "buttonTopBottomPadding": 10,
            "buttonLeftRightPadding": 10,
            "buttonBorderRadius": 3,
            "buttonWidth": "Auto",
            "buttonDialogLang": "English",
            "dialogLanguage": "en",
            "opt1": true,
            "op2": false,
            "maximumFiles": 6,
            "minimumfiles": 6,
            "opt3": false,
            "fopt1": false,
            "fopt2": false,
            "fopt3": true,
            "pdf": false,
            "word": false,
            "customFile": false,
            "fileTypes": [],
            "buttonStatus": "Disable",
            "textFieldName": "Notes:",
            "fieldHelpText": "",
            "textFieldMaxLength": "No",
            "textFieldMaxChars": "30",
            "textFieldRequired": "No",
            "textFieldRequiredMessage": "Please enter a text!",
            "textFieldrequiredMessageButtonText": "OK",
            "fileSizeRestriction": false,
            "fileSizeRestrictionType": "minimumFileRestriction",
            "fileSizeMinimumRestriction": "2",
            "fileSizeMaximumRestriction": "4",
            "fileSizeMinMaxMinimum": "2",
            "fileSizeMinMaxMaximum": "4",
            "no": false,
            "yes": true,
            "fileRequiredMessage": "Please choose photo for your rectangle magnet!",
            "fileRequiredMessageButtonText": "OK",
            "allowCropping": true,
            "croppingType": "aspect_ratio",
            "croppingAspectRatio": "3:4, 4:3",
            "allowEditing": true,
            "editingType": "required",
            "buttonStatus2": "Disable",
            "imageWidth": "1800",
            "imageHeight": "1200",
            "maxSizeRestriction": "Disable",
            "maxImageWidth": "1800",
            "maxImageHeight": "1200",
            "selectedUploadSources": "file facebook gdrive gphotos dropbox onedrive",
            "productCondition": {
                "condition": "",
                "products": [
                    "NFC Magnet"
                ],
                "productIds": [
                    "gid://shopify/Product/15058853069123"
                ],
                "collection": [],
                "collectionIds": [],
                "prodOpt": "",
                "prodTitleEqual": [],
                "prodTitleContains": [],
                "collOpt": "",
                "collectionTitleEqual": [],
                "collectionTitleContains": []
            },
            "allVariants": false,
            "anyConditionVariant": true,
            "allConditionVariant": false,
            "noneConditionVariant": false,
            "allVariantValues": [
                "Equals//?//Select Shape://?//Rectangle"
            ],
            "anyConditionCheck": false,
            "allConditionCheck": false,
            "showAllFields": false,
            "thisProduct": false,
            "thisCollection": false,
            "ucCustomTransalations": {
                "uploading": "Uploading... Please wait.",
                "loadingInfo": "Loading info...",
                "errors_default": "Error",
                "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
                "errors_baddata": "Incorrect value",
                "errors_size": "File too big",
                "errors_upload": "Can't upload",
                "errors_user": "Upload canceled",
                "errors_info": "Can't load info",
                "errors_image": "Only images allowed",
                "draghere": "Drop a file here",
                "one": "1 file",
                "file_other": "1 files",
                "buttons_cancel": "Cancel",
                "buttons_remove": "Remove",
                "buttons_choose_files_one": "Choose a file",
                "buttons_choose_files_other": "Choose files",
                "buttons_choose_images_one": "Choose an image",
                "buttons_choose_images_other": "Choose images",
                "dialog_close": "Close",
                "dialog_done": "Done",
                "dialog_showFiles": "Show files",
                "dialog_tabs_names_preview": "Preview",
                "dialog_tabs_names_file": "Local Files",
                "dialog_tabs_names_url": "Direct Link",
                "dialog_tabs_names_file_drag": "drag & drop<br>any files",
                "dialog_tabs_names_file_or": "or",
                "dialog_tabs_names_file_also": "or choose from",
                "dialog_tabs_names_file_button": "Choose a local file",
                "dialog_tabs_names_url_title": "Files from the Web",
                "dialog_tabs_names_url_line2": "Provide the link.",
                "dialog_tabs_names_url_input": "Paste your link here...",
                "dialog_tabs_names_url_button": "Upload",
                "dialog_tabs_names_camera_title": "File from web camera",
                "dialog_tabs_names_camera_capture": "Take a photo",
                "dialog_tabs_names_camera_mirror": "Mirror",
                "dialog_tabs_names_camera_startRecord": "Record a video",
                "dialog_tabs_names_camera_stopRecord": "Stop",
                "dialog_tabs_names_camera_retry": "Request permissions again",
                "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
                "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                "notFound_title": "No camera detected",
                "notFound_text": "Looks like you have no camera connected to this device.",
                "dialog_tabs_names_preview_back": "Back",
                "dialog_tabs_names_preview_done": "Add",
                "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
                "dialog_tabs_names_preview_regular_title": "Add this file?",
                "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
                "dialog_tabs_names_preview_regular_line2": "Please confirm.",
                "dialog_tabs_names_preview_image_title": "Add this image?",
                "dialog_tabs_names_preview_crop_title": "Crop and add this image",
                "dialog_tabs_names_preview_crop_free": "free",
                "dialog_tabs_names_preview_video_title": "Add this video?",
                "dialog_tabs_names_preview_error_default_title": "Oops!",
                "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
                "dialog_tabs_names_preview_error_default_back": "Please try again",
                "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
                "dialog_tabs_names_preview_multiple_question": "Add files?",
                "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
                "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
                "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
                "dialog_tabs_names_preview_multiple_clear": "Remove all",
                "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
                "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
                "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
                "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
                "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
                "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
                "effects_captions_blur": "Blur",
                "effects_captions_crop": "Crop",
                "effects_captions_enhance": "Enhance",
                "effects_captions_flip": "Flip",
                "effects_captions_grayscale": "Grayscale",
                "effects_captions_invert": "Invert",
                "effects_captions_mirror": "Mirror",
                "effects_captions_rotate": "Rotate",
                "effects_captions_sharp": "Sharpen",
                "effects_apply_button": "Apply"
            },
            "fileRequiredButton": "",
            "previewStyle": "tile_preview",
            "customStyling": {
                "container": "",
                "heading": "",
                "button": ""
            },
            "targetingType": "beginner",
            "thisProductVariants": true,
            "selectedProducts": [
                {
                    "id": "gid://shopify/Product/15058853069123",
                    "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Website_2__20250707_231539_0002.png?v=1754309003",
                    "title": "NFC Magnet",
                    "variants": [
                        {
                            "id": "gid://shopify/ProductVariant/53647640199491",
                            "title": "Rectangle",
                            "imageSrc": "https://cdn.shopify.com/s/files/1/0913/1838/7011/files/Spotify_20250707_231539_0003.png?v=1754309003"
                        }
                    ]
                }
            ],
            "fopt4": false,
            "fileExtensions": [],
            "pdf_settings": {
                "enabled": false,
                "minimum": 0,
                "maximum": 3
            },
            "translations": [
                {
                    "language": "Greek",
                    "translations": {
                        "buttonHeading": "Ανεβάστε τη φωτογραφία σας:",
                        "buttonText": "Επιλογή φωτογραφίας",
                        "buttonTextAfter": "Αλλαγή Εικόνας",
                        "desktopInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, χρησιμοποιείστε τους συνδέσμους στα αριστερά",
                        "mobileInstruction": "Επιλέξτε μία εικόνα από τη λίστα για να περικόψετε ή να επεξεργαστείτε. Για να προσθέσετε περισσότερες, επιλέξτε το εικονίδιο στο μενού πάνω αριστερά.",
                        "hint": "Αν αντιμετωπίζετε πρόβλημα να ανεβάσετε φωτογραφία, κλικ: πάνω δεξιά, μετά ‘Open in Chrome’",
                        "dialogLanguage": "Greek"
                    }
                }
            ]
        }
    ],
    "buy_button": true,
    "direct_link": false,
    "store_branding": false
}